import { Spinner } from '@platform/components';
import { ReactNode } from 'react';

type ReviewPageProps = {
  title: string;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  topRef: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
};

/**
 * Wrapper for admin pages requiring review action, handles loading and error states and scroll to top
 */
export const ReviewPageWrapper = (props: ReviewPageProps) => {
  const { title, isLoading, isError, isSuccess, topRef, children } = props;

  return (
    <div>
      {isLoading && (
        <div className='flex justify-center'>
          <Spinner />
        </div>
      )}
      {isError && <div>Error loading data</div>}
      {isSuccess && (
        <div ref={topRef} className='flex justify-center'>
          <div className='w-[800px] flex flex-col gap-2 border border-gray-100 p-6'>
            <h1 className='text-display-sm text-center'>{title}</h1>
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * Very basic formatting for review page items
 */
export const ReviewItem = ({ label, children }: { label: string; children: ReactNode }) => {
  return (
    <>
      <h2 className='text-xl font-semibold'>{label}</h2>
      {children}
    </>
  );
};
